<template>
     <v-layout wrap>
          <v-flex xs12>
               <v-card class="kim-card" style="overflow: visible">
                    <v-card-text class="py-1">
                         <v-layout wrap>
                              <v-flex xs12 class="pt-4 my-0 px-0" v-if="currentClient">
                                   <!--buttons-->
                                   <div class="top-btns">
                                        <!--Cancel appointment btn-->
                                        <template v-if="event.event_status.id < 4">
                                             <v-btn
                                                     @click="cancelAppointment"
                                                     rounded small :class="['mx-1 px-3 hidden-sm-and-down cancel-btn']" color="accent">
                                                  <v-icon class="mr-2" size="16">fa-times</v-icon>
                                                  Cancelar cita
                                             </v-btn>

                                             <v-btn
                                                     @click="cancelAppointment"
                                                     rounded small fab class="mx-1 px-3 hidden-md-and-up" color="accent">
                                                  <v-icon  size="16">fa-times</v-icon>
                                             </v-btn>
                                        </template>



                                        <!--Payment data btn-->
                                        <v-btn
                                                @click="editPayment"
                                                rounded  small  :class="['mx-1 px-3 hidden-sm-and-down payment-btn']" color="secondary">
                                             <v-icon class="mr-2" size="16">fa-money-check-alt</v-icon>
                                             {{paymentStatus}}
                                        </v-btn>

                                        <v-btn
                                                @click="editPayment"
                                                rounded small fab class="mx-1 px-3 hidden-md-and-up" color="secondary">
                                             <v-icon  size="16">fa-money-check-alt</v-icon>
                                        </v-btn>


                                        <!--Start Attention btn-->
                                        <template  v-if="event.event_status.id <= 3">
                                             <v-btn
                                                     rounded
                                                     small
                                                     :loading="loadingStart"
                                                     @click="startAttention"
                                                     class="mx-1 px-3 hidden-sm-and-down" color="primary">
                                                  <v-icon class="mr-2" size="16">fa-play</v-icon>
                                                  Iniciar atención
                                             </v-btn>

                                             <v-btn
                                                     rounded
                                                     small
                                                     :loading="loadingStart"
                                                     @click="startAttention"
                                                     fab class="mx-1 px-3 hidden-md-and-up" color="primary">
                                                  <v-icon size="16">fa-play</v-icon>
                                             </v-btn>
                                        </template>


                                        <!--End Attention btn-->
                                        <template v-if="event.event_status.id === 4">
                                             <v-btn
                                                     rounded
                                                     small
                                                     :loading="loadingStart"
                                                     @click="endAttention"
                                                     class="mx-1 hidden-sm-and-down  px-3" color="success">
                                                  <v-icon size="16" class="mr-2">fa-stop</v-icon>
                                                  Terminar atención
                                             </v-btn>

                                             <v-btn
                                                     rounded
                                                     small
                                                     fab
                                                     :loading="loadingStart"
                                                     @click="endAttention"
                                                     class="mx-1 hidden-md-and-up px-3" color="success">
                                                  <v-icon size="16">fa-stop</v-icon>
                                             </v-btn>
                                        </template>

                                     <!--Reopen Attention btn-->
                                     <template v-if="event.event_status.id === 5 && canReopen">
                                       <v-btn
                                           rounded
                                           small
                                           :loading="loadingStart"
                                           @click="reopenAttention"
                                           dark
                                           class="mx-1 hidden-sm-and-down px-3" color="blue">
                                         <v-icon size="16" class="mr-2">fa-redo-alt</v-icon>
                                         Reabrir atención
                                       </v-btn>

                                       <v-btn
                                           rounded
                                           small
                                           fab
                                           :loading="loadingStart"
                                           @click="reopenAttention"
                                           dark
                                           class="mx-1 hidden-md-and-up px-3" color="blue">
                                         <v-icon size="16">fa-redo-alt</v-icon>
                                       </v-btn>
                                     </template>

                                   </div>
                                   <v-layout wrap align-center>
                                        <v-flex xs12 md5 text-left pa-0>
                                             <v-list three-line class="py-0">
                                                  <v-list-item  >
                                                       <v-list-item-avatar>
                                                            <v-avatar size="45" class="mt-3">
                                                                 <v-img :src="currentClient.avatar || getFakeAvatar(currentClient.gender)"></v-img>
                                                            </v-avatar>
                                                       </v-list-item-avatar>

                                                       <v-list-item-content>
                                                            <v-list-item-title>{{currentClient.first_name}} {{currentClient.last_name || ''}}  {{currentClient.mother_last_name || ''}}</v-list-item-title>
                                                            <v-list-item-subtitle>
                                                                 <span class="font-weight-bold">{{clientLabel}}</span> <template v-if="event.event_status.id === 3 || event.event_status.id === 4">
                                                                      | <span class="hidden-sm-and-down mr-1">{{timeLabel}}</span> {{time}}
                                                                 </template>
                                                            </v-list-item-subtitle>
                                                       </v-list-item-content>

                                                  </v-list-item>
                                             </v-list>
                                        </v-flex>
                                        <v-flex v-if="event.companions.length > 0" xs12 pl-3 text-left>
                                             <v-chip class="user-chip" @click="setCurrentClient(companion)"  v-for="(companion, i) in otherClients" :key="companion.id">
                                                  <v-avatar size="25" class="mr-1">
                                                       <v-img :src="companion.avatar || getFakeAvatar(companion.gender)"></v-img>
                                                  </v-avatar>
                                                  {{companion.first_name}} {{companion.last_name && companion.last_name[0] + '.'}}
                                             </v-chip>
                                        </v-flex>

                                   </v-layout>
                              </v-flex>

                              <v-flex xs12 class="my-0 px-2 py-0  text-left mt-1">
                                   <div class="appointment-details-bar">

                                        <v-chip small outlined color="primary" class="mr-1 my-1">
                                             <v-icon size="15" class="mr-1">fa-calendar-alt</v-icon>
                                             {{event.date | humanDate}}
                                        </v-chip>

                                        <v-chip small outlined color="primary" class="mr-1 my-1">
                                             <v-icon size="16" class="mr-1">fa-clock</v-icon>
                                             {{$moment(event.time, 'HH:mm:ss').format('HH:mm')}}
                                        </v-chip>

                                        <event-status-chip :event-status="event.event_status" class="mr-1 my-1"/>

                                        <v-chip small outlined color="blue darken-2" v-if="currentClient && currentClient.insurance_company" class="mr-1 my-1">
                                             <v-icon size="16" class="mr-1">fa-briefcase</v-icon>
                                             {{currentClient.insurance_company.name}}
                                        </v-chip>

                                        <v-chip  small dark  outlined color="green darken-2" class="mr-1 my-1">
                                             <v-icon size="14" class="mr-2">{{currentClient && currentClient.isNew ? 'far fa-file' : 'far fa-file-alt'}}</v-icon>
                                             {{currentClient && currentClient.isNew ? 'Nuevo' : 'Antiguo'}}
                                        </v-chip>

                                        <v-chip v-if="event.type === 'video'" @click="vcDialog = true" small dark outlined color="grey darken-2" class="my-1">
                                             <v-icon size="14" class="mr-2">fa-video</v-icon>
                                             Video llamada
                                        </v-chip>
                                   </div>
                              </v-flex>

                              <v-flex xs12 text-left py-1 px-2 v-if="event.event_status.id >= 3">
                                   <v-textarea
                                           :disabled="event.event_status.id !== 4"
                                           auto-grow
                                           outlined
                                           hide-details
                                           v-model="reason"
                                           :loading="loadingUpdateReason"
                                           label="Motivo de la cita"
                                           placeholder="No se ha indicado motivo"
                                           rows="1" :value="reason" />
                              </v-flex>

                             <v-flex xs12 v-if="currentProviderSettings && currentProviderSettings.allow_labels_on_appointments">
                               <v-sheet outlined style="border-radius: 10px;" class="secondary-card mx-2 px-3 mt-2">
                                 <v-row align="center" no-gutters class="py-2">
                                   <v-col cols="10" class="text-left pb-0">
                                     <v-icon size="18" class="mr-1">mdi-label</v-icon>Etiquetas:
                                   </v-col>
                                   <v-col cols="2" class="text-right pr-1">
                                     <v-btn small fab  color="secondary" @click="showLabelDetails = true">
                                       <v-icon>mdi-pencil</v-icon>
                                     </v-btn>
                                   </v-col>
                                   <v-col cols="12" class="mt-0">
                                     <div class="text-caption text-left pl-3" v-if="!event.labels || event.labels.length === 0">
                                       No se han agregado etiquetas
                                     </div>
                                     <event-labels v-else :labels="event.labels" />
                                   </v-col>
                                 </v-row>
                               </v-sheet>
                                <labels-details-dialog
                                    @close="showLabelDetails = false"
                                    :show="showLabelDetails"
                                    :history="event.labels_history"
                                    :labels="event.labels"
                                    :event-id="event.id"
                                    @change="onLabelsChange"
                                    />
                             </v-flex>
                         </v-layout>

                         <v-card flat color="secondary-card" class="kim-card flat mx-2 my-2" >
                              <v-layout wrap px-4 py-3>

                                   <v-btn style="z-index: 2" small color="secondary" fab absolute  right @click="onClientEditClick(currentClient)">
                                        <v-icon>mdi-pencil</v-icon>
                                   </v-btn>

                                   <v-flex xs12 md5 v-if="currentClient">
                                        <v-flex xs12 class="body-2 mb-2 text-left">
                                             <v-icon size="20" class="mr-1" >mdi-account</v-icon>
                                             <span class="subtitle">Datos:</span>
                                        </v-flex>
                                        <v-layout wrap pl-2>
                                             <v-flex xs12 text-left>
                                                  <span class="font-weight-bold">RUT:</span> {{currentClient.dni && rutFormat(currentClient.dni) || 'n/d'}}
                                             </v-flex>
                                             <v-flex xs12 text-left>
                                                  <span class="font-weight-bold">Edad:</span> {{currentClient.birth_date && `${$moment().diff($moment(currentClient.birth_date), 'years')} años`  || 'n/d'}}
                                             </v-flex>
                                             <v-flex xs12 text-left text-truncate>
                                                  <div>
                                                       <span class="font-weight-bold">Dirección:</span> {{currentClient.address || 'n/d'}}
                                                  </div>
                                             </v-flex>
                                             <v-flex xs12 text-left text-truncate v-if="currentClient.address_line1">
                                                  <div>
                                                       <span class="font-weight-bold">Casa/Dpto/Local:</span> {{currentClient.address_line1}}
                                                  </div>
                                             </v-flex>
                                        </v-layout>
                                   </v-flex>

                                   <v-flex xs12 pa-0  my-2 hidden-md-and-up>
                                        <v-divider></v-divider>
                                   </v-flex>

                                   <v-flex xs12 md7 v-if="currentClient">
                                        <v-flex xs12 class="body-2 mb-2 text-left blue-grey--text">
                                          <v-sheet color="transparent" height="14px"></v-sheet>
                                        </v-flex>
                                        <v-layout wrap pl-2>
                                             <v-flex xs12 text-left>
                                                  <span class="font-weight-bold">Teléfono (móvil):</span> {{currentClient.phone1 || 'n/d'}}
                                             </v-flex>
                                             <v-flex xs12 text-left>
                                                  <span class="font-weight-bold">Teléfono (fijo):</span> {{currentClient.phone2 || 'n/d'}}
                                             </v-flex>
                                             <v-flex xs12 text-left text-truncate >
                                                  <div :title="currentClient.email">
                                                       <span class="font-weight-bold">E-mail:</span> {{currentClient.email || 'n/d'}}
                                                  </div>
                                             </v-flex>

                                        </v-layout>
                                   </v-flex>

                              </v-layout>
                         </v-card>
                    </v-card-text>
               </v-card>
          </v-flex>

          <v-dialog max-width="500" v-model="endAttentionDialog">

               <component
                    :is="endAttentionComponent"
                    :event="event"
                    @cancel="endAttentionDialog = false"
                    @confirm="confirmEndAttention"
                    :loading="loadingEnd"
               />

          </v-dialog>

          <v-dialog v-model="vcDialog" max-width="500">
               <v-card >
                    <v-card-title>
                         <h1 class="headline">
                              <v-icon color="black" class="mr-2" size="26">fa-video</v-icon>
                              Videollamada
                         </h1>
                         <v-spacer></v-spacer>
                         <v-icon @click="vcDialog = false">far fa-times-circle</v-icon>
                    </v-card-title>
                    <v-card-text class="pt-1 mb-0">
                         <v-alert
                                 style="border-radius: 10px"
                                 class="mb-3 caption"
                                 :value="true"
                                 color="accent"
                                 outlined
                                 icon="fa-exclamation-circle"
                         >
                              - <b>{{ appName }}</b> automáticamente envía el link por e-mail y whatsapp a tu {{clientSingular.toLowerCase()}}, esta es solo una alternativa adicional.
                              <br>
                              - Tu <b>no</b> necesitas ingresar a este link, es <b>solo para {{clientSingular.toLowerCase()}}</b>.
                         </v-alert>
                         <v-sheet height="80">
                              <v-text-field
                                      :hint="vcHint"
                                      ref="vcLink"
                                      @focus="$event.target.select()"
                                      label="Link de la videollamada"
                                      :value="videoUrl"
                                      readonly outlined
                                      append-icon="far fa-copy"
                                      @click:append="copyVCLink"
                              />
                         </v-sheet>
                    </v-card-text>
                    <v-card-actions class="">
                         <v-spacer></v-spacer>
                         <v-btn color="green darken-1" rounded depressed outlined :href="`https://wa.me/?text=${encodeURIComponent(videoUrl)}`" target="_blank">
                              <v-icon class="mr-2">fab fa-whatsapp</v-icon>
                              enviar por whatsapp
                         </v-btn>
                    </v-card-actions>
               </v-card>
          </v-dialog>

          <cancel-appointment ref="cancelAppointment" @success="cancelSuccess"/>
          <payment-edit ref="paymentEditForm" @success="onPaymentUpdated"/>
          <client-edit
                  :required-fields="requiredFields"
                  :requested-fields="requestedFields"
                  ref="clientEditForm"
                  @success="onClientUpdated"
          />

     </v-layout>

</template>

<script>

     import {ApiUtils} from '@/utils/ApiUtils'
     import {mapMutations, mapState} from 'vuex'

     import {getFakeAvatar, rutFormat, debounce} from '@/utils/Common'
     import {getLabel} from '@/utils/Institution'
     import {
       endAttentionComponentByService
     } from '@/utils/Specialist'
     import {getCompanionLabel} from '@/utils/ScheduleEvent'
     import {getLabel as getPaymentLabel} from '@/utils/Payment'

     import EventStatusChip from '@/components/appointments/EventStatusChip'
     import PaymentEdit from '@/components/payment/PaymentEdit'
     import CancelAppointment from '@/components/appointments/CancelAppointment'

     import ClientEdit from '@/components/appointments/ClientEdit'

     import PsychologistEndAttention from '@/components/appointments/attention/specialties_panels/psychology_widgets/PsychologistEndAttention'
     import TechnologistEndAttention from '@/components/appointments/attention/specialties_panels/technologist_widgets/TechnologistEndAttention'
     import DefaultEndAttention from '@/components/appointments/attention/specialties_panels/DefaultEndAttention'
     import EventLabels from "@/components/appointments/attention/EventLabels";
     import LabelsDetailsDialog from "@/components/appointments/details/LabelsDetailsDialog";
     import ProviderSettingsMixin from "@/mixins/ProviderSettingsMixin";

    export default{
         components: {
           LabelsDetailsDialog,
           EventLabels,
              DefaultEndAttention,
              PsychologistEndAttention,
              TechnologistEndAttention,
              EventStatusChip,
              PaymentEdit,
              ClientEdit,
              CancelAppointment
         },
         props: ['event'],
         mixins: [ProviderSettingsMixin],
         data(vm){
              return {
                   time: 'calculando...',
                   vcHint: '',
                   payment: vm.event && vm.event.payment || null,
                   timeInterval: null,
                   showLabelDetails: false,
                   loadingUpdateReason: false,
                   loadingStart: false,
                   loadingEnd: false,
                   vcDialog: false,
                   reason: vm.event && (vm.event.reason_description || (vm.event.appointment_reason && vm.event.appointment_reason.description)) || '',
                   endAttentionDialog: false,
                   derivationType: 'discharge'
              }
         },
         mounted(){
              var vm = this
              vm.setTimeData()
              if(!!vm.event && !!vm.event.client){
                   vm.setCurrentClient(vm.event.client)
              }
         },
         beforeDestroy(){
              var vm = this
              clearInterval(vm.timeInterval)
              vm.setCurrentClient(null)
         },
        watch:{
          reason(){
               this.debouncedUpdateReason()
          },
          event(val){
               var vm = this
               vm.setTimeData()
               if(val){
                    vm.setCurrentClient(val.client)
               }else{
                    vm.setCurrentClient(null)
               }

          },
          vcDialog(val){
             if(val){
                  this.vcHint = ''
             }
          }
        },
         computed: {
              ...mapState('clientAttention', {
                   currentClient: state => state.currentClient
              }),
                 ...mapState(['currentProvider']),
              endAttentionComponent(){
                const vm = this
                if(!vm.event || !vm.event.schedule || !vm.event.schedule.service_item) return null
                return endAttentionComponentByService(vm.event.schedule.service_item.description)
              },
              canReopen(){
                const vm = this
                if(!vm.currentProvider || vm.event.event_status_id !== 5) return false
                const {settings} = vm.currentProvider
                if(!settings.can_reopen_attention) return false
                const now = vm.$moment()
                const eventEndedAt = vm.$moment(vm.event.attention_ended_at)
                eventEndedAt.add(settings.max_hours_reopen_attention, 'hours')
                return eventEndedAt.isSameOrAfter(now)
              },
              requiredFields(){
                   var vm = this
                   if(!vm.currentProvider || !vm.currentProvider.settings || !vm.currentProvider.settings.client_form_fields) return []
                   return vm.currentProvider.settings.client_form_fields
                           .filter(field => field.pivot.required)
                           .map(field => field.name)
              },
              requestedFields(){
                   var vm = this
                   if(!vm.currentProvider || !vm.currentProvider.settings || !vm.currentProvider.settings.client_form_fields) return []
                   return vm.currentProvider.settings.client_form_fields
                           .map(field => field.name)
              },
              clientLabel(){

                   var vm = this
                    if(!vm.event || !vm.event.client || !vm.currentClient) return ''

                   const relationship = vm.currentClient.pivot && vm.currentClient.pivot.relationship || null

                   if(relationship){
                        return getCompanionLabel(relationship)
                   }

                    var label = ''
                    if(vm.event.client.id === vm.currentClient.id){

                         label = `${getLabel('commons.client.singular')}`

                         if(vm.event.companions.length > 0){
                              label += ' principal'
                         }

                         return label

                    }

                    return ''

              },
              otherClients(){
                   var vm = this
                   if(!vm.event || !vm.event.companions) return []

                   var allUsers = [
                           vm.event.client,
                           ...vm.event.companions
                   ]

                   return allUsers.filter(usr => usr.id !== vm.currentClient.id)

              },
              videoUrl(){
                   if(this.event.type !== 'video') return ''
                   return window.location.origin + '/videocall/' + this.event.vc_id
              },
              paymentStatus(){

                   var vm = this

                   if(!vm.event || !vm.event.payment) return 'Pago pendiente'
                   if(vm.event.payment.type === 'free') return 'Cita sin costo'

                   return getPaymentLabel(vm.event.payment.status_detail)

              },
              timeLabel(){
                   var vm = this

                   if(vm.event.event_status.id === 4){
                        return 'En atención:'
                   }

                   return 'En espera:'

              }
         },
         methods: {
                 ...mapMutations(['showSnackBar']),
              ...mapMutations('clientAttention', [
                  'setCurrentClient',
                  'setEvent'
              ]),
              getLabel,
              rutFormat,
              getFakeAvatar,
              onLabelsChange(labels){
                const vm = this
                const event = JSON.parse(JSON.stringify(vm.event))
                event.labels_history = labels
                vm.setEvent(event)
              },
              onClientEditClick(client){
                   var vm = this
                   vm.$refs.clientEditForm.show(client)
              },
              onClientUpdated(client){
                   var vm = this
                   vm.$refs.clientEditForm.hide()
                   vm.$emit('edit:client', client)
              },
              onPaymentUpdated(payment){
                   var vm = this
                    vm.$refs.paymentEditForm.hide()
              },
              cancelSuccess(evt){
                //do something
                   this.$emit('appointment:cancel', evt)
              },
              cancelAppointment(){
                    var vm = this
                    vm.$refs.cancelAppointment.show(vm.event.id)
              },
              editPayment(){
                    var vm = this
                    vm.$refs.paymentEditForm.show(vm.event)
              },
              copyVCLink(event){
                   var vm = this

                   vm.$refs.vcLink.focus()
                   document.execCommand("copy");
                   vm.vcHint = '¡URL copiada!'
              },
              async startAttention(){
                   var vm = this

                   if(vm.loadingStart) return

                   vm.loadingStart = true
                   const response = await ApiUtils.makePost(`appointments/${vm.event.id}/attention/start`)
                   vm.loadingStart = false

                   if(!response.ok){
                        const json = await response.json()
                        vm.showSnackBar(json.message || 'Ha ocurrido un error intentando iniciar la atencion')
                        return
                   }

                   const json = await response.json()
                   vm.$emit('attention:start', json.result.event)

              },
              async reopenAttention(){
                   var vm = this

                   if(vm.loadingStart) return

                   vm.loadingStart = true
                   const response = await ApiUtils.makePost(`appointments/${vm.event.id}/attention/reopen`)
                   vm.loadingStart = false

                   if(!response.ok){
                        const json = await response.json()
                        vm.showSnackBar(json.message || 'Ha ocurrido un error intentando reabrir la ficha')
                        return
                   }

                   const json = await response.json()
                   vm.$emit('attention:start', json.result.event)

              },
              async confirmEndAttention(config){
                   var vm = this



                   if(vm.loadingEnd) return

                   vm.loadingEnd = true
                   const response = await ApiUtils.makePost(`appointments/${vm.event.id}/attention/end`, config)
                   vm.loadingEnd = false

                   if(!response.ok){
                        const json = await response.json()
                        vm.showSnackBar(json.message || 'Ha ocurrido un error intentando terminar la atencion')
                        return
                   }

                   vm.endAttentionDialog = false
                   const json = await response.json()
                   vm.$emit('attention:end', json.result.event)

              },
             endAttention(){
                  var vm = this
                  vm.endAttentionDialog = true
             },
              debouncedUpdateReason: debounce(function(){
                   this.updateReason()
              }, 1000),
              async updateReason(){
                   var vm = this
                    if(vm.loadingUpdateReason) return

                   vm.loadingUpdateReason = true
                   const response = await ApiUtils.makePatch(`event/${vm.event.id}/appointment/reason`, null, {
                         description: vm.reason
                   })
                   vm.loadingUpdateReason = false

                   //'event/{eventId}/appointment/reason'
              },
              setTimeData(){
                   var vm = this
                   clearInterval(vm.timeInterval)
                   vm.timeInterval = setInterval(function(){

                        if(!vm.event || !vm.event.event_status || vm.event.event_status.id < 3){
                             vm.time = '-'
                             return
                        }

                        const diff = vm.event.event_status.id === 3 ?
                                vm.$moment().diff(vm.$moment(vm.event.arrived_at)) :
                                vm.$moment().diff(vm.$moment(vm.event.attention_started_at))

                        const duration = vm.$moment.duration(diff)
                        if(duration.hours() === 0 && duration.minutes() === 0){
                             var humanized = 'unos segundos'
                        }else{

                             var hoursForHumans = duration.hours() > 0 ? `${duration.hours()} hr${duration.hours() > 1 ? 's' : ''}.` : ''
                             var minutesForHumans =  duration.minutes() > 0 ? `${duration.minutes()} min${duration.minutes() > 1 ? 's' : ''}.` : ''

                             if(hoursForHumans && minutesForHumans){
                                  var humanized =  `${hoursForHumans} y ${minutesForHumans}`
                             }else{
                                  var humanized = hoursForHumans ? `${hoursForHumans}` : `${minutesForHumans}`
                             }

                        }

                        vm.time = humanized

                   }, 1000)
              }
         }
    }
</script>

<style scoped>

     .top-btns{
          position: absolute;
          top: -17px;
          right: 10px
     }

     .payment-btn.start-margin{
          margin-right: 175px;
     }

     .payment-btn.stop-margin{
          margin-right: 190px;
     }

     .payment-btn.start-margin{
          margin-right: 175px;
     }

     .payment-btn.stop-margin{
          margin-right: 190px;
     }
     .appointment-details-bar{
          border-radius: 5px;
          padding: 10px 5px
     }

     .user-chip{
          min-width: 120px;
     }

</style>
